
import * as React from 'react';
import { Props } from './../types/types';
import { TouchableOpacity, Text, Icon, rem } from './../libs/WebComponents';


const ButtonReadMore = (props: Props)=>{

   props = { 
      labelText: props.labelText || 'Lees meer over',
      className: props.className || '',
      style: props.style,
      iconSize: props.iconSize || rem(3.5),
      color: 'var(--bs-body-color)',
      ...props
   };
   return (
      <TouchableOpacity onPress={props.onPress} className={'button-read-more ' + props.className} style={props.style}>
         <Icon name={'Readmore'} color={props.color} size={props.iconSize} style={{borderColor:props.color,...props.style}}/><Text style={{color:props.color}}>{props.labelText}</Text></TouchableOpacity>
   );
}

export default React.memo(ButtonReadMore);